/**
 * SlxControls 1.2.41 ({@link https://www.selerix.com})
 * This is unpublished proprietary source code of Selerix Systems, Inc. The
 * copyright notice above is not evidence any actual or intended
 * publication of such source code.
 * @copyright Copyright 2025 Selerix Systems, Inc. All Rights Reserved.
 */
(function (global) {
	'use strict';
	var x = global.SlxControl;

	/**
	 * slx.progressBar
	 * @requires slx.core
	 * @constructs
	 */
	x.slx.progressBar = function () {
		var that = this;
		x.slx.base.apply(that, arguments);

		// reference current element
		var el = that._element;
		if (el === void 0) { return this; }
		else if (el.length === 0) { return el; }

		// set custom settings from data props and attributes
		that.id = that.id || el.slxUniqueId();
		that.selector = '#' + that.id;
		// progress order
		that._ord = el.data('progress-order');
		if (typeof (that._ord) === 'string') { that._ord = that._ord.replaceAll(' ', '').split(','); }
		that.progressOrder = that.progressOrder || that._ord || ['default', 'success', 'info', 'warning', 'danger'];
		that.progressBars = that.progressBars || [];
		that.container = x(that.selector + '_container');
		that.onChange = typeof that.onChange === 'function' ? that.onChange : el.attr('onchange') !== void 0 ? x.eval.call(el[0], el.attr('onchange'), 'event') : void 0;
		that.overlays = that.overlays !== void 0 ? that.overlays : el.data('overlays') !== void 0 ? el.data('overlays') : true;
		that.tooltips = that.tooltips !== void 0 ? that.tooltips : el.data('tooltips') !== void 0 ? el.data('tooltips') : true;
		that.tooltipPlacement = that.tooltipPlacement || el.data('tooltip-placement') || 'top';
		that.active = that.active || el.data('active') || false;

		delete that._ord;

		// get and set values of progress bars
		that.value = function (index, val) {
			var v = arguments.length === 1 ? index : val;
			var i = arguments.length <= 1 ? 0 : index;

			// get progress bar by index
			var b = that.progressBars[i];
			if (arguments.length === 0) { return b.value; }
			b.value = v;

			// set progress value
			if (that.progressBars.length === 0) return el.slxVal.apply(el, arguments);

			// get progress bar element
			var bar = el.children('.progress-bar:nth-child(' + (i + 1) + ')');
			var ischange = bar.aria('valuenow') !== v;

			// calculate values
			var w = (b.value / b.max) * 100;
			var txt = parseInt(w, 10) + '%';
			// update values
			bar.aria('valuenow', v).css({ width: w + '%' });
			if (that.tooltips) { bar.attr('data-original-title', txt); }
			// trigger change event
			if (ischange) {
				if (that.overlays) { that.text(i, txt); }
				el.trigger('change');
			}

			return that;
		};
		// get and set text of progress bars
		that.text = function (index, val) {
			var v = arguments.length === 1 ? index : val;
			var i = arguments.length <= 1 ? 0 : index;

			// get progress bar by index
			var b = that.progressBars[i];
			if (arguments.length === 0) { return b.text; }
			b.text = v;

			// update text of progress bar element
			var bar = el.children('.progress-bar:nth-child(' + (i + 1) + ')');
			return bar.slxText(v);
		};
		// set progress by index
		that.progress = function (index) {
			var i = index || 0;
			if (that.progressBars.length <= i) { return {}; }
			return that.progressBars[i];
		};
		// get total progress
		that.total = function (length) {
			var t = 0;
			var n = length === void 0 ? that.progressBars.length - 1 : length;
			for (var i = 0; i < n; i++) {
				var p = that.progress(i).value;
				t += p >= 0 ? p : 0;
			}
			return t;
		};
		// build progress bars
		that.build = function() {
			el.empty();

			// update progress bar values
			for (var i = 0; i < that.progressBars.length; i++) {
				var bar = that.progressBars[i];
				bar.theme = bar.theme || 'default';
				bar.value = bar.value || 0;
				bar.text = bar.value || '';
				bar.min = bar.min || 0;
				bar.max = bar.max || 100;
				bar.active = bar.active || false;

				// calculate values
				var w = (bar.value / bar.max) * 100;
				bar.text = parseInt(w, 10) + '%';
				var themeClass = 'slx-progress-bar-' + bar.theme;
				if (x.slx.config.bootstrap === 3) {
					// set theme for bootstrap 3
					themeClass = 'progress-bar-' + bar.theme;
				} else if (x.slx.config.bootstrap >= 4) {
					// set theme for bootstrap >= 4
					themeClass = 'bg-' + bar.theme;
				}

				// add progress bar to DOM
				var p = x('<DIV/>').addClass('progress-bar').addClass(themeClass).attr('role','progressbar').aria('valuenow', bar.value).aria('valuemin', bar.min).aria('valuemax', bar.max);
				if (bar.active) { p.addClass('progress-bar-striped active'); }
				p.css({ width: w + '%' });
				el.append(p);

				// add overlays and tooltips
				if (that.overlays) { p.text(bar.text); }
				if (that.tooltips) {
					p.attr('data-toggle', 'tooltip').attr('data-placement', that.tooltipPlacement).attr('title', bar.text);
					p.tooltip();
				}
			}
		};

		/* initialization */
		(function () {
			// wrap in container if needed
			if (that.container.length === 0) {
				el.wrap(x('<DIV/>').attr('id', that.id + '_container').attr('data-target', that.selector).addClass('slx-progress-container'));
				that.container = x(that.selector + '_container');
			}
			// add classes as needed
			if (!el.hasClass('slx-progress')) { el.addClass('slx-progress'); }
			if (!el.hasClass('progress')) { el.addClass('progress'); }

			// add progress bars
			var i, p, d, a;
			if (that.progressBars.length === 0) {
				for (i = 0; i < that.progressOrder.length; i++) {
					p = that.progressOrder[i], d = p === 'default' ? 'value' : p, a = p === 'default' ? that.active : el.data(p + '-active') || false;
					if (el.data(d) !== void 0) {
						that.progressBars.push({
							theme: p,
							value: el.data(d),
							text: el.data(p + '-text'),
							min: el.data(p + '-min'),
							max: el.data(p + '-max'),
							active: a
						});
					}
				}
			}
			// add at least one default progress bar if needed
			if (that.progressBars.length === 0) {
				that.progressBars.push({
					theme: 'default',
					value: el.data('value'),
					text: el.data('default-text'),
					min: el.data('default-min'),
					min: el.data('default-max'),
					active: that.active
				});
			}

			that.build();

			// trigger render event
			if (that.toString() === '[progressBar]') { setTimeout(function () { el.trigger('render'); }, 0); }
		})();

		/* events */
		(function () {
			// element change event
			el.off('change.slx.pb').on('change.slx.pb', function (event) {
				if (typeof that.onChange === 'function') {
					that.onChange.call(el[0], event);
				}
			});
		})();

		// register control w/ element
		el[0].slxProgressBar = this;
		el[0].isSlxControl = true;

		return el;
	};
	// update constructor
	x.slx.progressBar.prototype = Object.create(x.slx.base.prototype);
	x.slx.progressBar.prototype.constructor = x.slx.progressBar;

	/* extenders */
	x.slx.extend({
		// add control init extension
		slxProgressBar: function () {
			var slx = this.slxControl('slxProgressBar', arguments) || new x.slx.progressBar(this, arguments);
			if (arguments.length > 0) {
				var arg = arguments[0], args = Array.prototype.slice.call(arguments, 1);
				if (typeof arg === 'string' && slx.hasOwnProperty(arg)) { return typeof slx[arg] === 'function' ? slx[arg].apply(slx, args) : slx[arg]; }
				else if (typeof arg !== 'string') { x.extend(slx, arg); }
			}
			return this;
		}
	});
	
	// register control
	x.slx.register('slxProgressBar', x.slx.slxProgressBar);

	// initialize all controls by CSS class
	x(function () { x('.slx-progress').each(function () { x(this).slxProgressBar(); }); });

	return x;
})(window || this);